interface Props {
  username: string;
  onPlay: () => void;
  onLeaderboard: () => void;
}

export default function MainMenu({ username, onPlay, onLeaderboard }: Props) {
  return (
    <div className="screen">
      <div className="arcade-title">TARGET RUSH<br />GLOBAL ARENA</div>
      <div className="panel" style={{ width: 340, textAlign: 'center' }}>
        <div className="arcade-subtitle" style={{ marginBottom: 18 }}>
          Welcome back, {username}
        </div>
        <div className="menu-grid" style={{ gridTemplateColumns: '1fr' }}>
          <button className="arcade-btn" onClick={onPlay}>
            Classic Mode
          </button>
          <button className="arcade-btn secondary" onClick={onLeaderboard}>
            Global Leaderboard
          </button>
        </div>
        <div className="hint" style={{ marginTop: 18 }}>
          Desert Range · Classic Mode · 30s survival
        </div>
      </div>
    </div>
  );
}
